<template>
  <div class="ds-drop-down" role="option">
    <div
      @click.stop.prevent="openDropdownWithSearchOption()"
      class="ds-drop-down__select"
      :class="{ active: openDropdown }"
      role="select"
    >
      <span v-if="!hasSearch" class="ds-drop-down__placeholder-select">{{ placeholderSelect }}</span>
      <div v-if="hasSearch" class="ds-drop-down__search">
        <div class="ds-drop-down__icon-search">
          <DsIcon :name="`search`" />
        </div>
        <input
          v-model="searchValue"
          type="text"
          class="ds-drop-down__search"
          :placeholder="placeholderInputSearch"
          @keyup="searchOption(searchValue)"
        />
      </div>
      <div @click.stop.prevent="toogleDropdown()" class="ds-drop-down__icon" >
        <DsIcon :name="`menu${openDropdown ? '-down' : '-up'}`" />
      </div>
    </div>
    <div
      v-if="openDropdown"
      :class="getOptionsClass()"
    >
      <div
        v-if="hasCustomContent"
        class="ds-drop-down__custom-content"
      >
        <slot />
      </div>
      <template v-else>
        <div
          class="ds-drop-down__items select-all"
          v-if="hasSelectAll"
          @click.stop.prevent="selectingAll()"
          data-testid="select-all"
        >
          <DsCheckbox
            id="all-selected"
            v-model="allSelected"
            :disabled="isLimitSelect"
            :label="labelSelectAll"
          />
        </div>
        <div
          class="ds-drop-down__items select"
          v-for="item in optionsList"
          :key="item.id"
          @click.stop.prevent="toogleOption(item.id)"
          data-testid="select-option"
        >
          <DsCheckbox
            :id="`${item.id}`"
            v-model="item.selected"
            :disabled="item.disabled"
            :label="item.title"
          />
        </div>
      </template>
    </div>
    <span class="ds-drop-down__top-border">
      <label>{{ required ? `${label} *` : label }}</label>
    </span>

  </div>
</template>

<script>
import Vue from 'vue';
import DsCheckbox from '../Checkbox/Checkbox.vue';
import DsIcon  from '../../icons/Icon.vue';

export default Vue.extend({
  name: 'DsDropdown',
  components: {
    DsCheckbox,
    DsIcon
  },
  props: {
    listItens: {
      type: Array,
      required: true
    },
    limit: {
      type: Number,
      default: null
    },
    labelSelectAll: {
      type: String,
      default: 'Todos'
    },
    label: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    selectAll: {
      type: Boolean,
      default: false
    },
    hasSelectAll: {
      type: Boolean,
      required: false,
      default: false
    },
    hasSearch: {
      type: Boolean,
      required: false,
      default: false
    },
    placeholderSelect: {
      type: String,
      required: false,
      default: 'Placeholder'
    },
    dark: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      allSelected: false,
      isLimitSelect: false,
      limited: false,
      optionsList: [],
      countSelected: 0,
      selectedControl: [],
      openDropdown: false,
      searchValue: '',
      placeholderInputSearch: 'Pesquisar'
    };
  },
  watch: {
    countSelected() {
      if (this.limit <= 0 && this.limit != null) {
        return;
      }

      if (this.countSelected >= this.limit && !this.limited && this.limit != null) {
        this.limitSelectionOfOptions(true);
        this.limited = true;
        return;
      }

      if (this.limited) {
        this.limitSelectionOfOptions(false);
        this.limited = false;
        this.allSelected = false;
      }

      if (this.countSelected < this.limit && this.limit != null) {
        this.allSelected = false;
      }

      if (
        (this.limit == null && this.countSelected == this.optionsList.length) ||
        (this.limit != null && this.countSelected == this.limit )) {
        this.allSelected = true;
      }

      if (this.limit == null && this.countSelected < this.optionsList.length){
        this.allSelected = false;
      }
    }
  },
  created() {
    const mappedOptions = this.listItens.map(({ id, title }) => ({
      id,
      title,
      selected: false,
      disabled: false,
    }));
    this.selectedControl = mappedOptions;
    this.optionsList = mappedOptions;

    window.addEventListener('click', (e) => {
      if (!this.$el.contains(e.target) && this.openDropdown == true) {
        this.toogleDropdown();
      }
    });
    if (this.limit < this.listItens.length && this.limit != null) {
      this.isLimitSelect = true;
    }
    if (this.selectAll) {
      this.selectingAll();
    }
  },
  computed: {
    hasCustomContent() {
      return Boolean(this.$slots.default);
    },
  },
  methods: {
    selectingAll() {
      const arrayLabels = ['selectedControl', 'optionsList'];
      if (this.isLimitSelect) {
        return;
      }
      if (!this.allSelected) {
        arrayLabels.forEach((label) => {
          this[label] = this.changeValue(this[label], {
            verificationParameter: this.conditionalToDisableOrSelectOption,
            processingFunction: this.reverseSelectionValue
          });
        });
        this.allSelected = !this.allSelected;
      } else {
        arrayLabels.forEach((label) => {
          this[label] = this.changeValue(this[label], {
            verificationParameter: this.conditionalToRemoveSelectOption,
            processingFunction: this.reverseSelectionValue
          });
        });
        this.allSelected = !this.allSelected;
      }
    },
    limitSelectionOfOptions(disabled) {
      const arrayLabels = ['selectedControl', 'optionsList'];
      arrayLabels.forEach((label) => {
        this[label] = this.changeValue(this[label], {
          disabled,
          verificationParameter: this.conditionalToDisableOrSelectOption,
          processingFunction: this.reverseDisabledValue,
        });
      });
    },
    toogleOption(id) {
      const arrayLabels = ['selectedControl', 'optionsList'];
      arrayLabels.forEach((label) => {
        this[label] = this.changeValue(this[label], {
          id,
          verificationParameter: this.conditionalForSelection,
          processingFunction: this.reverseSelectionValue,
        });
      });
      this.countSelected = this.selectedControl.reduce((acc, option) => {
        return option.selected ? acc + 1 : acc;
      }, 0);
    },
    reverseSelectionValue(option) {
      return {
        id: option.id,
        title: option.title,
        selected: !option.selected,
        disabled: option.disabled,
      };
    },
    reverseDisabledValue(option, disabled) {
      return {
        id: option.id,
        title: option.title,
        selected: option.selected,
        disabled,
      };
    },
    conditionalForSelection(option, id) {
      return option.id === id && !option.disabled;
    },
    conditionalToDisableOrSelectOption(option) {
      return !option.selected;
    },
    conditionalToRemoveSelectOption(option) {
      return option.selected;
    },
    changeValue(list, { verificationParameter, processingFunction, id, disabled }) {
      return list.map(option => (verificationParameter(option, id) ? processingFunction(option, disabled) : option));
    },
    searchOption(value) {
      this.optionsList = this.selectedControl.filter(option => option.title.toLowerCase().includes(value.toLowerCase()));
    },
    toogleDropdown() {
      this.openDropdown = !this.openDropdown;
      if (!this.openDropdown) {
        this.clearSearch();
      }
    },
    clearSearch() {
      this.searchValue = '';
      this.searchOption(this.searchValue);
    },
    openDropdownWithSearchOption() {
      if (!this.searchValue && this.countSelected == 0) {
        this.toogleDropdown();
      }else {
        this.openDropdown = true;
      }
    },
    getOptionsClass() {
      return {
        'ds-drop-down__options': true,
        'ds-drop-down__options-custom': this.hasCustomContent
      };
    },
  },
  mounted() {
    // @ts-ignore
    document.documentElement.setAttribute('data-color-theme', this.dark ? 'dark' : '');
  }
});
</script>

<style lang="scss" scoped>
@import '~@ds/styles/Dropdown.scss';
</style>